import { AuthTokenResponseSchema } from '@repo/schema/user'
import { z } from '@repo/schema'

export const loginSchema = z.object({
  email: z.email({ message: "That doesn't look like a valid email" }),
  password: z
    .string({ message: 'Please enter your password' })
    .min(8, { message: 'Password must be at least 8 characters' }),
})

export const LoginOutputSchema = AuthTokenResponseSchema
